import HealthQuestionnaires from '@/pages/HealthQuestionnaire';
import { ROUTES } from './routes.config';
import { AuthGuard } from '@/rtkQuery/features/services/auth';

export const HealthQuestionnairesRoutes = {
    path: ROUTES.HEALTH_QUESTIONNAIRES,
    element: <AuthGuard><HealthQuestionnaires /> </AuthGuard>,
};
